import React, { useState } from "react";
import "./Pay.css";
import close from "./close.png";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { savePayment, saveTransaction } from "../../service/saveTransactions";

const Pay = ({ showPayModal, closePayModal, userPayInfo, selectedId }) => {
  const [paymentAmount, setPaymentAmount] = useState(""); // State for payment amount
  const [paymentProof, setPaymentProof] = useState(null); // State for payment proof (file)

  // Handle file change
  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setPaymentProof(e.target.files[0]);
    }
  };

  // Handle payment submission (optional)
  const handlePayClick = async () => {
    if (!paymentAmount || !paymentProof) {
      alert("Please provide payment amount and upload proof.");
      return;
    }

    try {
      // Initialize Firebase storage
      const storage = getStorage();
      const storageRef = ref(
        storage,
        `transactions/${selectedId}/${paymentProof.name}`
      );

      // Upload the proof file to Firebase Storage
      const snapshot = await uploadBytes(storageRef, paymentProof);

      // Get the download URL for the uploaded file
      const proofUrl = await getDownloadURL(snapshot.ref);
      console.log("I D", selectedId);

      // Save the transaction with the provided details
      await saveTransaction(
        "admin_payout",
        "debit",
        selectedId,
        paymentAmount,
        proofUrl,
        "Paid to trainer"
      );
      await savePayment(selectedId, paymentAmount, proofUrl);

      // Success message
      alert("Transaction saved successfully!");
      console.log("Transaction saved successfully with the following details:");
      console.log({
        userId: selectedId,
        amount: paymentAmount,
        proofUrl,
        reason: "Paid to trainer",
      });

      // Reset modal and states
      setPaymentAmount("");
      setPaymentProof(null);
      closePayModal();
    } catch (error) {
      console.error("Error during payment process:", error);
      alert("Failed to process the transaction. Please try again.");
    }
  };

  return (
    // <div
    //   className={showPayModal ? "modal display-block" : "modal display-none"}
    // >
    //   <section className="modal-main">
    //     <div className="closebtn" onClick={closePayModal}>
    //       <img src={close} alt="Close" />
    //     </div>
    //     <div className="mainc">
    //       <h1 className="headinga">Are you sure?</h1>
    //       <div className="middlecontent">
    //         <p>First Name = {userPayInfo?.firstName || "NA"} </p>
    //         <p>Account Number = {userPayInfo?.accountNumber || "NA"} </p>
    //         <p>Account Type = {userPayInfo?.accountType || "NA"}</p>
    //         <p>IFSC Code = {userPayInfo?.ifscCode || "NA"}</p>
    //       </div>

    //       <div className="input-section">
    //         <div className="input-wrapper">
    //           <label htmlFor="paymentAmount" className="label">
    //             Enter Payment Amount:
    //           </label>
    //           <input
    //             type="number"
    //             id="paymentAmount"
    //             className="input"
    //             value={paymentAmount}
    //             onChange={(e) => setPaymentAmount(e.target.value)}
    //             placeholder="Enter amount"
    //             required
    //           />
    //         </div>

    //         <div className="input-wrapper">
    //           <label htmlFor="paymentProof" className="label">
    //             Upload Payment Proof:
    //           </label>
    //           <input
    //             type="file"
    //             id="paymentProof"
    //             className="file-input"
    //             accept="image/*"
    //             onChange={handleFileChange}
    //             required
    //           />
    //           {paymentProof && (
    //             <p className="file-name">Selected File: {paymentProof.name}</p>
    //           )}
    //         </div>
    //       </div>

    //       <div className="btnc">
    //         <div onClick={closePayModal} className="btn">
    //           Cancel
    //         </div>
    //         <div onClick={handlePayClick} className="btn">
    //           Pay
    //         </div>
    //       </div>
    //     </div>
    //   </section>
    // </div>

    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity ${
        showPayModal
          ? "opacity-100 pointer-events-auto"
          : "opacity-0 pointer-events-none"
      }`}
    >
      <section className="bg-gray-900 text-white rounded-2xl shadow-xl w-full max-w-md p-6 relative transform transition-transform scale-100">
        {/* Close Button */}
        <button
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition"
          onClick={closePayModal}
        >
          <img src={close} alt="Close" className="w-3 h-3" />
        </button>

        {/* Heading */}
        <h2 className="text-2xl font-bold text-center mb-6">Confirm Payment</h2>

        {/* User Info */}
        <div className="bg-gray-900 border border-gray-700  rounded-xl p-5 mb-6 space-y-2">
          <p>
            <span className="font-semibold">First Name:</span>{" "}
            {userPayInfo?.firstName || "NA"}
          </p>
          <p>
            <span className="font-semibold">Account Number:</span>{" "}
            {userPayInfo?.accountNumber || "NA"}
          </p>
          <p>
            <span className="font-semibold">Account Type:</span>{" "}
            {userPayInfo?.accountType || "NA"}
          </p>
          <p>
            <span className="font-semibold">IFSC Code:</span>{" "}
            {userPayInfo?.ifscCode || "NA"}
          </p>
        </div>

        {/* Inputs */}
        <div className="space-y-5 mb-6">
          <div>
            <label
              htmlFor="paymentAmount"
              className="block text-sm font-medium mb-1"
            >
              Enter Payment Amount
            </label>
            <input
              type="number"
              id="paymentAmount"
              className="w-full border border-gray-700 rounded-lg px-3 py-2 bg-gray-900 text-white placeholder-gray-500 "
              value={paymentAmount}
              onChange={(e) => setPaymentAmount(e.target.value)}
              placeholder="Enter amount"
              required
            />
          </div>

          <div>
            <label
              htmlFor="paymentProof"
              className="block text-sm font-medium mb-1"
            >
              Upload Payment Proof
            </label>
            <input
              type="file"
              id="paymentProof"
              className="w-full border border-gray-700 rounded-lg px-3 py-2 bg-gray-900 text-white placeholder-gray-500"
              accept="image/*"
              onChange={handleFileChange}
              required
            />
            {paymentProof && (
              <p className="text-sm text-gray-400 mt-1">
                Selected File: {paymentProof.name}
              </p>
            )}
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-3">
          <button
            onClick={closePayModal}
            className="w-24 text-center px-4 py-3 rounded-lg font-bold text-black text-sm bg-gradient-to-r from-[#B17E32] via-[#F3E681] to-[#CF9F41] hover:opacity-90 transition font-poppins"
          >
            Cancel
          </button>
          <button
            onClick={handlePayClick}
            className="w-24 text-center px-4 py-3 rounded-lg font-bold text-black text-sm bg-gradient-to-r from-[#B17E32] via-[#F3E681] to-[#CF9F41] hover:opacity-90 transition font-poppins"
          >
            Pay
          </button>
        </div>
      </section>
    </div>
  );
};

export default Pay;
